import React, { useState, useEffect } from 'react';
import { DateTimePicker } from '@mui/x-date-pickers';
import PermissionToRender from '../../../../components/Permission/PermissionToRender';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { SummaryTransportation } from './summaryTransportation';
import { CustomModal } from './customModal';
import { SeatModal } from './seatModal';
import { UnileverColumns } from './ExcelColumns/unileverColumns';
import { TransportationColumns } from './ExcelColumns/transportationColumns';
import { CardColumns } from './ExcelColumns/cardColumns';
import {
  prepareCardsRow,
  prepareTransportationRows,
  prepareUnileverRow,
} from './ExcelRows';

import {
  TextField,
  Button,
  Autocomplete,
  Box,
  useMediaQuery,
  CircularProgress,
} from '@mui/material/';
import { GridActionsCellItem } from '@mui/x-data-grid';
import { useDashboardStore } from '../store/store';

import { useInstance } from '../hooks/useInstance';
import useExportExcel from '../hooks/useExportExcel';

import { columns } from '../columns/cardEventsForATransportation';

import moment from 'moment';
//import ExcelJS from 'exceljs';
//import { saveAs } from 'file-saver';
//import { ca } from 'date-fns/locale';

const oneDayInMillis = 24 * 60 * 60 * 1000;
const initialValue = {
  t0: new Date(new Date().getTime() - oneDayInMillis).getTime(),
  t1: Date.now(),
};
const cardEventContainer = () => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [openSeatModal, setOpenSeatModal] = useState(false);
  const handleOpenSeatModal = () => setOpenSeatModal(true);
  const handleCloseSeatModal = () => setOpenSeatModal(false);
  const [selectedTransportation, setSelectedTransportation] = useState(null);
  const initialState = {
    t0: initialValue.t0,
    t1: initialValue.t1,
    vehicleId: '',
  };
  const {
    carsModal,
    fetchOptionsForCarAutoComplete,
    fetchCarTransportations,
    fetchSeatAndBelt,
    optionsForCarAutoComplete,
    loadingOptionsForCarAutoComplete,
    loadingCarTransportations,
    carTransportations,
    cards,
    cardsLoading,
    cardsPage,
    cardsSortModel,
    cardsPageCount,
    setCardsSortModel,
    fetchCards,
    setCardsPage,
    fetchLocationData,
    allCardsByTransportation,
    resetAllLayerExceptOne,
    resetCarTransportations,
  } = useDashboardStore((state) => state);

  const [formState, dispatch] = React.useReducer((state, action) => {
    switch (action.type) {
      case 'CHANGE_FIELD':
        return { ...state, vehicleId: action.value };
      case 'CHANGE_DATE':
        return {
          ...state,
          [action.field]: action.value,
        };
      default:
        return state;
    }
  }, initialState);
  const isMobile = useMediaQuery('(max-width:1024px)');
  const instance = useInstance();
  const createExcelTransportation = useExportExcel(
    TransportationColumns,
    carTransportations,
    prepareTransportationRows,
    `${formState.vehicleId} | ${moment(formState.t0).format(
      'DD/MM/YYYY',
    )} - ${moment(formState.t1).format('DD/MM/YYYY')}`,
  );
  const createExcelUnilever = useExportExcel(
    UnileverColumns,
    carTransportations,
    prepareUnileverRow,
    `${formState.vehicleId} | ${moment(formState.t0).format(
      'DD/MM/YYYY',
    )} - ${moment(formState.t1).format('DD/MM/YYYY')}`,
  );
  const createExcelCards = useExportExcel(
    CardColumns,
    allCardsByTransportation,
    prepareCardsRow,
    `${selectedTransportation?.transportation?.content} |${formState.vehicleId} Görev Kart Raporu`,
  );

  // const createExcelTransportation = () => {
  //   return new Excel(
  //     TransportationColumns,
  //     carTransportations,
  //     prepareTransportationRows,
  //     `${formState.vehicleId} | ${moment(formState.t0).format(
  //       'DD/MM/YYYY',
  //     )} - ${moment(formState.t1).format('DD/MM/YYYY')}`,
  //   ).createExcel();
  // };
  // const createExcelUnilever = () => {

  //   return new Excel(
  //     UnileverColumns,
  //     carTransportations,
  //     prepareUnileverRow,
  //     `${formState.vehicleId} | ${moment(formState.t0).format(
  //       'DD/MM/YYYY',
  //     )} - ${moment(formState.t1).format('DD/MM/YYYY')}`,
  //   ).createExcel();
  // };
  // const createExcelCards = () => {

  //   return new Excel(
  //     CardColumns,
  //     allCardsByTransportation,
  //     prepareCardsRow,
  //     `${selectedTransportation?.transportation?.content} |${formState.vehicleId} Görev Kart Raporu`,
  //   ).createExcel();
  // };

  const cardModal = {
    open: open,
    handleClose: handleClose,
    downloadExcel: () => createExcelCards(),
    columns: columns,
    rows: cards,
    sortModel: cardsSortModel,
    setSortModel: setCardsSortModel,
    paginationChange: paginationChange,
    page: cardsPage,
    count: cardsPageCount,
    isMobile: isMobile,
    selectedTransportation: selectedTransportation,
    plate: formState.vehicleId,
    allCardsByTransportation: allCardsByTransportation,
    resetAllLayerExceptOne: resetAllLayerExceptOne,
  };

  function paginationChange(_, e_page) {
    setCardsPage(e_page - 1);
  }
  useEffect(() => {
    setCardsPage(0);
  }, [selectedTransportation]);

  useEffect(() => {
    if (selectedTransportation === null || '') return;
    fetchCards({
      transportationId: selectedTransportation?.id,
      isMobile: isMobile,
    });
  }, [cardsPage, cardsSortModel]);
  useEffect(() => {
    const column = {
      field: 'actions',
      headerName: 'Göster',
      type: 'actions',
      width: 150,
      notFilter: true,
      getActions: (params) => [
        <GridActionsCellItem
          key={params.id}
          icon={<LocationOnIcon />}
          label="Haritada Göster"
          onClick={() => {
            resetAllLayerExceptOne('LCards', [params.row]);
          }}
        ></GridActionsCellItem>,
      ],
    };
    columns.push(column);
    return () => {
      columns.pop();
    };
  }, []);

  useEffect(() => {
    fetchOptionsForCarAutoComplete({ query: '' });
  }, []);

  return (
    <div
      id="carOvermap"
      className={`${
        carsModal ? '' : 'hidden'
      }  flex flex-col gap-3 p-3 text-xs absolute top-40 left-5 bg-white w-72 rounded-xl  z-30 `}
    >
      <Autocomplete
        isOptionEqualToValue={(option, value) => option === value}
        options={optionsForCarAutoComplete || []}
        getOptionLabel={(option) => option}
        fullWidth
        loading={loadingOptionsForCarAutoComplete}
        size="small"
        renderInput={(params) => (
          <TextField
            {...params}
            size="small"
            variant="outlined"
            placeholder="Araç plakasını şeçiniz"
            label="Araç plakası"
          />
        )}
        onChange={(event, newValue) => {
          resetCarTransportations();
          dispatch({
            type: 'CHANGE_FIELD',
            value: newValue,
          });
        }}
      />
      <DateTimePicker
        label="Başlangıç Tarihi"
        ampm={false}
        inputFormat="dd/MM/yyyy hh:mm"
        maxDateTime={formState.t1}
        value={formState.t0}
        onChange={(e) =>
          dispatch({
            type: 'CHANGE_DATE',
            field: 't0',
            value: e,
          })
        }
        slots={{ textField: TextField }}
        slotProps={{ textField: { size: 'small', fullWidth: true } }}
      />
      <DateTimePicker
        label="Bitiş Tarihi"
        ampm={false}
        inputFormat="dd/MM/yyyy hh:mm"
        value={formState.t1}
        minDateTime={formState.t0}
        maxDateTime={Date.now()}
        onChange={(e) =>
          dispatch({
            type: 'CHANGE_DATE',
            field: 't1',
            value: e,
          })
        }
        slotProps={{ textField: { size: 'small', fullWidth: true } }}
        disableIgnoringDatePartForTimeValidation
      />

      <Button
        variant="outlined"
        sx={{ width: '100%' }}
        onClick={() => {
          fetchCarTransportations(formState);
        }}
      >
        Filtrele
      </Button>

      {carTransportations?.length !== 0 && (
        <Autocomplete
          noOptionsText="Sefer bulunamadı"
          loading={loadingCarTransportations}
          loadingText={'yükleniyor...'}
          options={carTransportations}
          getOptionLabel={(option) =>
            `${moment(option.createdAt).format('DD/MM/YYYY | HH:mm') || ''}`
          }
          renderOption={(props, option) => (
            <Box component="li" {...props} key={option.id}>
              <div className="flex flex-col">
                <p className="text-xs">
                  {moment(option.createdAt).format('DD/MM/YYYY | HH:mm')}
                </p>
                <p className="text-xs">
                  {option?.transportation?.content || ''}
                </p>
              </div>
            </Box>
          )}
          fullWidth
          renderInput={(params) => (
            <TextField
              {...params}
              size="small"
              variant="outlined"
              placeholder="Sefer adı şeçiniz"
              label="Sefer Adı"
            />
          )}
          onChange={(event, newValue) => {
            setSelectedTransportation(newValue);
          }}
        />
      )}
      {carTransportations?.length !== 0 && (
        <Button
          variant="outlined"
          onClick={() => {
            if (instance === null) {
              return;
            }
            if (instance?.id !== 'amir-al0') {
              createExcelTransportation();
            } else {
              createExcelUnilever();
            }
          }}
        >
          GÖREVLERİ DIŞA AKTAR
        </Button>
      )}

      {carTransportations?.length !== 0 && selectedTransportation && (
        <SummaryTransportation
          transportationEventFormData={selectedTransportation}
        />
      )}

      {carTransportations?.length !== 0 && selectedTransportation && (
        <PermissionToRender instanceCanView={['amir-tr0']}>
          <Button
            className="livetracking-container-filter-area-filter-button"
            variant="contained"
            sx={{ backgroundColor: '#2e3448' }}
            onClick={() => {
              if (selectedTransportation === null) return;
              fetchLocationData(selectedTransportation?.id);
            }}
          >
            Haritada Göster
          </Button>
          <Button
            onClick={() => {
              handleOpen();
              fetchCards({
                transportationId: selectedTransportation?.id,
                isMobile: isMobile,
              });
            }}
            className="livetracking-container-filter-area-filter-button  "
            variant="contained"
            sx={{ backgroundColor: '#2e3448', width: 'full' }}
          >
            Görev Kart Raporu Göster
          </Button>
          {cardsLoading ? (
            <div className="flex items-center justify-center">
              <CircularProgress />
            </div>
          ) : (
            <CustomModal {...cardModal}></CustomModal>
          )}
        </PermissionToRender>
      )}

      {carTransportations.length !== 0 && selectedTransportation && (
        <PermissionToRender instanceCanView={['amir-al0']}>
          <Button
            variant="contained"
            sx={{ backgroundColor: '#2e3448' }}
            onClick={() => {
              if (selectedTransportation === null) return;
              fetchSeatAndBelt(selectedTransportation?.id);
            }}
          >
            <div className="flex items-center justify-center">
              Koltuk Durumlarını Haritada Göster
            </div>
          </Button>
          <Button
            variant="contained"
            sx={{ backgroundColor: '#2e3448' }}
            onClick={handleOpenSeatModal}
          >
            Zamana Göre Koltuk Durumları
          </Button>
          <SeatModal
            openSeatModal={openSeatModal}
            handleCloseSeatModal={handleCloseSeatModal}
            transportationEventFormData={selectedTransportation}
          />
        </PermissionToRender>
      )}
    </div>
  );
};
export default cardEventContainer;
